import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { normalizeImgSrc } from '../utils';

//Satellite Grid Section
export const buildSatelliteGridCenterSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));

  if (!newSection?.html) return null;

  const center_media = suggestionFields?.content?.center_media || null;
  const headingHtml = `${suggestionFields?.content?.heading ? `<h2>${suggestionFields?.content?.heading}</h2>` : ''} ${
    suggestionFields?.content?.subheading ? `<p>${suggestionFields?.content?.subheading}</p>` : ''
  }`;

  const listItem =
    (suggestionFields?.content?.grid_items || []).map(item => {
      return {
        title: item.title,
        description: item.description,
        image: normalizeImgSrc(item.image_url || ''),
      };
    }) || [];

  const fieldUpdate = {
    enableAnchor: false,
    title: 'Satellite Grid Section',
    'main-title-satellite': headingHtml,
    'main-image-satellite': normalizeImgSrc(center_media.url || ''),
    'items-satellite': listItem,
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionSatelliteGrid(newSection.html, fieldUpdate),
  };
};
